import { useCoachSession } from "@/hooks/useCoachSession";
import { Button, Card, Chip, SectionTitle } from "@/components/primitives";

// Phase 0 voice-client spike harness. Exercises the full AudioEngine code path
// (mic capture -> worklet -> WS, playback scheduling, keepalives) so the bundler
// processes the engine + worklet. A live, authenticated session requires the
// same-origin Fly deploy (the WS rides the session cookie), so locally this
// proves the pipeline wires up and the worklet loads — not a completed session.
export function SpikePage() {
  const sessionId = new URLSearchParams(location.search).get("sid") ?? "spike-demo";
  const { state, transcript, usage, error, start, pause, resume, nextQuestion, end } =
    useCoachSession(sessionId);

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-5">
      <h1 className="text-2xl font-semibold text-ink">Voice spike</h1>
      <Card>
        <SectionTitle>Engine state</SectionTitle>
        <div className="flex items-center gap-3">
          <Chip variant={state === "error" ? "warn" : "accent"}>{state}</Chip>
          {usage && (
            <span className="font-mono text-[11px] text-slate-500">
              tokens in/out: {usage.inputTokens}/{usage.outputTokens}
            </span>
          )}
        </div>
        {error && <p className="mt-2 text-sm text-crit">{error}</p>}
        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="accent" onClick={() => void start()}>
            Start
          </Button>
          <Button variant="ghost" onClick={pause}>
            Pause
          </Button>
          <Button variant="ghost" onClick={resume}>
            Resume
          </Button>
          <Button variant="ghost" onClick={nextQuestion}>
            Next question
          </Button>
          <Button variant="danger" onClick={end}>
            End
          </Button>
        </div>
      </Card>
      <Card>
        <SectionTitle>Transcript</SectionTitle>
        {transcript.length === 0 ? (
          <p className="text-sm text-slate-400">No turns yet.</p>
        ) : (
          <ul className="space-y-2">
            {transcript.map((t, i) => (
              <li key={i} className="text-sm">
                <span className="font-mono text-[10px] uppercase text-slate-500 mr-2">{t.role}</span>
                {t.text}
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
